// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class KeyValueGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.KEY_VALUE_GROUP, null, pfixFieldSet);
    }
    getKey() {
        return this.GetValue(FieldsFactory.FIELD_KEY);
    }
    setKey(key) {
        this.SetField(FieldsFactory.FIELD_KEY, key);
    }
    getValue() {
        return this.GetValue(FieldsFactory.FIELD_VALUE);
    }
    setValue(val) {
        this.SetField(FieldsFactory.FIELD_VALUE, val);
    }
}
